import { Component, ChangeDetectionStrategy, Inject, OnInit } from '@angular/core';

import { SnAspectRatio } from '@lib/common/enums';
import { GOOGLE_MAP_POPUP_DATA } from '@lib/geo/google/map';

import { SentryActionsService } from '../../services/sentry-actions.service';

@Component({
  selector: 'fs-sentry-camera-view-popup',
  templateUrl: './sentry-camera-popup.component.html',
  styleUrls: ['./sentry-camera-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SentryActionsService],
})
export class SentryCameraPopupComponent implements OnInit {
  public aspectRatio = SnAspectRatio.Classic;
  public showIsInLoop = false;

  constructor(
    @Inject(GOOGLE_MAP_POPUP_DATA) public readonly data: any,
    private readonly _sentryActionsService: SentryActionsService,
  ) {}

  public ngOnInit(): void {
    const currentTime = new Date().getTime();
    const duration = this.data.camera.loopDuration * 60 * 1000;
    const loopTime = currentTime - duration;

    const currentLoop = new Date(this.data.item.timestamp).getTime();

    this.showIsInLoop = loopTime < currentLoop;
  }

  public clip(url: any): void {
    this._sentryActionsService.clip(url);
  }

  public setViewClip(item: any, data: any): void {
    this._sentryActionsService.setViewClip(item, data);
  }

  public viewDetectionDetails(): void {
    this._sentryActionsService.viewDetectionDetails(
      this.data.item,
      this.data.item.detectionsFiltered[0],
      this.data.queryParams,
    );
  }

  public sendToVault(url: string): void {
    this._sentryActionsService.sendToVault(url);
  }

  public selectChannel(url: any): void {
    this._sentryActionsService.selectChannel(url);
  }

  public incorrectSentryResult(detectionItem: any, cameraDetections: any): void {
    this._sentryActionsService.incorrectSentryResult(
      detectionItem,
      cameraDetections.item.detections[0],
      this.data.queryParams,
    );
  }

  public reported(): boolean {
    return this._sentryActionsService.getReported();
  }

  public reporting(): boolean {
    return this._sentryActionsService.getReporting();
  }
}
